var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticStyle:{"margin-bottom":"30px","margin-top":"60px"}},[_c('h3',{staticClass:"text-center mt-12 text-h2 text-xs-h4 text-sm-h3 primary--text font-weight-lightest text-uppercase"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }